export interface IBaseEvent {
  type: EventBusName;
}

export interface IBaseEventPayload<Payload> {
  type: EventBusName;
  payload: Payload;
}

export enum EventBusName {
  SHOW_MODAL_CONFIRM,
  SHOW_MODAL_PROFILE,
  ERROR,
}
